<mat-menu #settingsMenu="matMenu" class="loren-settings-menu">
  <span class="loren-settings-menu-header">{{
    "toolbar.assets" | transloco
  }}</span>
  <mat-divider class="loren-settings-menu-divider"></mat-divider>

  <div class="loren-settings-menu-content">
    @for (item of assetSettingsMenuItems; track item) {
    <button
      *lorenFeatureToggle="item.featureToggle"
      mat-menu-item
      class="loren-settings-menu-item"
      routerLinkActive="active-link"
      [routerLink]="item.path">
      <span class="loren-settings-menu-item-text">{{
        item.title | transloco
      }}</span>
    </button>
    }
  </div>

  <span class="loren-settings-menu-header">{{
    "toolbar.users" | transloco
  }}</span>
  <mat-divider class="loren-settings-menu-divider"></mat-divider>
  @for (item of userSettingsMenuItems; track item) {
  <button
    mat-menu-item
    class="loren-settings-menu-item"
    routerLinkActive="active-link"
    [routerLink]="item.path">
    <span class="loren-settings-menu-item-text">{{
      item.title | transloco
    }}</span>
  </button>
  }
</mat-menu>

<div
  [matMenuTriggerFor]="settingsMenu"
  [tourAnchor]="settingsAnchorId"
  [matTooltip]="'tooltips.settings' | transloco"
  class="loren-settings-menu-button-container">
  <button
    mat-icon-button
    aria-label="Settings menu"
    class="loren-settings-menu-button"
    [disableRipple]="true">
    <mat-icon class="loren-settings-menu-button-icon">settings</mat-icon>
  </button>

  @if(!isHandset) {
  <span class="loren-settings-menu-button-text">
    {{ "toolbar.settings" | transloco }}
  </span>
  }
</div>
